import { useState } from "react";
import { Avatar, Button, Popover } from "@mui/material";
import { useAuth } from "features/auth";
import { ArrowRightStartOnRectangleIcon } from "@heroicons/react/24/outline";
import { menuButtonStyle, headerAvatarStyle } from "./styles";

export const HeaderUserMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const auth = useAuth();
  const isOpened = Boolean(anchorEl);
  const id = isOpened ? "user-menu-popover" : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async () => {
    await auth.signOut();
  };

  return (
    <div>
      <Button aria-describedby={id} onClick={handleClick} sx={menuButtonStyle}>
        {auth.user?.email}
        <Avatar sx={headerAvatarStyle} />
      </Button>
      <Popover
        id={id}
        open={isOpened}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Button
          onClick={handleSignOut}
          variant="outlined"
          startIcon={<ArrowRightStartOnRectangleIcon width="16" height="16" />}
          sx={{
            textTransform: "none",
          }}
        >
          Sign out.
        </Button>
      </Popover>
    </div>
  );
};
